module.exports = __webpack_public_path__ + "static/lights5-c376d6bccea2f0499ce69b85c9cd18ad.jpg";